import { ConsentTtlService } from '../adapters/optanon-consent-ttl/consent-ttl.service'
import { logger } from '@otto-ec/eprivacy-shared'
import { GetConsentTtlPort } from '../ports'

export type { GetConsentTtlPort } from '../ports'

const consentTtlService = new ConsentTtlService(logger)

export const getConsentTtl: GetConsentTtlPort =
  consentTtlService.getConsentTtl.bind(consentTtlService)
